export default {
  deepCopy: function (obj, copy) {
    for (var i in obj) {
      if (typeof obj[i] == 'object') { // 判断是否为对象
        this.deepCopy(obj[i], copy[i]); // 回调深拷贝函数
      } else {
        copy[i] = obj[i]; // 不是对象直接复制
      }
    }
    return copy;
  },
  iteration (data, callback) {
    for (var j = 0; j < data.length; j++) {
      if (callback) {
        callback(data[j])
      }
      if (data[j].children != undefined && data[j].children.length > 0) {
        this.iteration(data[j].children, callback)
      }
    }
  },
  getCurrentStrWidth (text, font) {
    var currentObj = $('<span>').hide().appendTo(document.body);
    $(currentObj).html(text).css('font', font);
    var width = currentObj.width();
    currentObj.remove();
    return width;
  }
}



// WEBPACK FOOTER //
// ./src/components/common/treeview/utils.js